import { Component } from 'react';

import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { get, isArray } from 'lodash';
import { WithStyles, withStyles } from '@mui/styles';

import APStepContainer from './../../components/organisms/APStepContainer';
import ReferralSent from './ReferralSent';

import { actions as ReferralActions } from '../../redux/modules/refer';
import { actions as servicesDowntimeAction } from '../../redux/modules/servicesDowntime';
import { ReducerState } from './../../redux/modules';
import { withTranslate, withTenant } from '../../core/TenantProvider';

import { REFER_CLIENT_FORM } from './definitions/refer';
import ReferContainerStyles from './styles/ReferContainer.style';
import _ from 'lodash';
import APBackdropLoader from '../../components/atoms/APBackdropLoader';

import APAlertMessage from '../../components/atoms/APAlertMessage';

import Cookies from 'js-cookie';
import { TriggerGoogleAnalytics4Tag, TriggerGoogleAnalyticsTag } from '../../core/utils/GoogleAnalyticTag';
import { GoogleAnalyticTags } from '../../core/utils/GoogleAnalyticTag/GoogleAnalyticsTags';
import { GoogleAnalytics4Tags } from '../../core/utils/GoogleAnalyticTag/GoogleAnalytics4Tags';
import { EtvOptions } from '../../redux/modules/refer/reducer';
import { Affiliate, AffiliateDetailsAttributes } from '../../core/types/AffiliateDetails';
import { DialingCodeObj } from '../../core/utils/GetDialingCode/GetDialingCode';
import { GetDialingCodeWithAuth } from '../../core/utils/GetDialingCode';
import { PARTNER, PFX, WEBLEADS_V5_API_SUCCESS_CODE } from '../../core/utils/Constants/Constants';
import {
  APStepContainerAffiliateReferrals,
  APStepContainerClientReferrals,
  APStepContainerFormForReferrals,
  StepDefinition
} from '../../core/types/APStepContainerTypes';
import { ReferClientForm, SwitchOption } from '../../core/types/ReferContainerTypes';

interface ReferContainerProps extends WithStyles<typeof ReferContainerStyles> {
  loadingState: string,
  referClient: Function,
  referAffiliate: Function,
  getETVDetails: Function,
  translate: Function,
  affiliateDetails: AffiliateDetailsAttributes | null,
  settings: any,
  etvOptions: EtvOptions,
  getServicesErrorObj: Function
}

class ReferContainer extends Component<ReferContainerProps, {}> {
  state = {
    complete: false,
    step: 0,
    steps: [],
    isAlertToBeShown: false,
    stepsData: REFER_CLIENT_FORM
  };

  constructor(props: ReferContainerProps) {
    super(props);

    this.onClear = this.onClear.bind(this);
    this.onComplete = this.onComplete.bind(this);
    this.onContinue = this.onContinue.bind(this);
    this.onBack = this.onBack.bind(this);
    this.getStepData = this.getStepData.bind(this);
  }

  onClear() {
    this.setState({
      complete: false
    });
  }

  sendToReferAffiliate = (formData: APStepContainerAffiliateReferrals, affiliate: Affiliate) => {
    const {
      referAffiliate,
      getServicesErrorObj,
    } = this.props;

    referAffiliate(formData, affiliate).then((response: any) => {
      const code: string | null = get(response, 'code', null);
      const description: string | null = get(response, 'description', null);
      if (code === "2000" || description === "Referred Affiliate Record  inserted Successfully") {
        this.setState({
          complete: true
        });
      }
    })
      .catch((error: unknown) => {
        getServicesErrorObj(error);
        this.setState({
          isAlertToBeShown: true
        });
      });
  }

  sendToReferClient = (formData: APStepContainerClientReferrals, affiliate: Affiliate) => {
    const {
      referClient,
      getServicesErrorObj,
    } = this.props;

    referClient(formData, affiliate).then((response: any) => {
      const responseCode: string = response.code;
      if (responseCode === WEBLEADS_V5_API_SUCCESS_CODE) {
        this.setState({
          complete: true
        });
        TriggerGoogleAnalyticsTag(
          GoogleAnalyticTags.eventAction.load,
          GoogleAnalyticTags.referAClient.load.clientSuccessfullyReferredPageLoad
        );
        TriggerGoogleAnalytics4Tag(
          GoogleAnalytics4Tags.referAClient.name,
          GoogleAnalytics4Tags.eventAction.load,
          GoogleAnalytics4Tags.referAClient.load.clientSuccessfullyReferredPageLoad
        );
      }
    })
      .catch((error: unknown) => {
        getServicesErrorObj(error);
        this.setState({
          isAlertToBeShown: true
        });
      });
  }

  onComplete(form: APStepContainerFormForReferrals, step: number, steps: Array<StepDefinition>) {
    const {
      affiliateDetails
    } = this.props;

    this.setState({
      step: step,
      steps: steps
    });

    const affiliate: Affiliate | undefined = affiliateDetails?.affiliate;
    let requiredFormData = _.omit(form, ['phone.displayName', 'mobile.displayName', 'account', 'address', 'isJoint', 'jointAddress', 'jointMobile']);

    if (requiredFormData.customerType === 'PARTNER') {
      this.sendToReferAffiliate(requiredFormData as APStepContainerAffiliateReferrals, affiliate as Affiliate)
    } else {
      requiredFormData = _.omit(form, ['is_referral_agreed_to_share_contact_info', 'nature_of_business', 'client_type', 'website', 'address', 'account', 'isJoint', 'jointAddress']);
      this.sendToReferClient(requiredFormData as APStepContainerClientReferrals, affiliate as Affiliate)
    }
  }

  onContinue(step: number, steps: Array<StepDefinition>) {
    this.setState({
      step: step,
      steps: steps
    });
  }

  onBack(step: number, steps: Array<StepDefinition>) {
    this.setState({
      step: step,
      steps: steps
    });
  }

  getStepData(clientType: string = PFX) {
    const { affiliateDetails } = this.props;
    const isReferPartnerDisable: boolean | undefined = affiliateDetails?.affiliate.disable_partner_referrals;

    const referClientForm: ReferClientForm[] = _.cloneDeep(REFER_CLIENT_FORM);
    const customerTypeOption: SwitchOption[] = referClientForm[0].sections[0].switch?.options as SwitchOption[];
    isReferPartnerDisable && _.remove(customerTypeOption, option => option.value === PARTNER);

    const referFormSteps = referClientForm.map((stepObject) => {
      if (stepObject.condition) {
        const checkArrayConditions: boolean = isArray(stepObject.condition.value) && !stepObject.condition.value.includes(clientType);
        if (checkArrayConditions) {
          return null;
        }
      }
      return stepObject;
    }).filter((stepData) => stepData !== null);

    this.setState({ stepsData: referFormSteps });
  }


  componentDidMount() {
    this.getStepData();
    const { affiliateDetails, getETVDetails } = this.props;
    const affiliate = affiliateDetails?.affiliate;

    getETVDetails(affiliate?.legal_entity);

    TriggerGoogleAnalyticsTag(
      GoogleAnalyticTags.eventAction.load,
      GoogleAnalyticTags.referAClient.load.personalDetailsPageLoad
    );
    TriggerGoogleAnalytics4Tag(
      GoogleAnalytics4Tags.referAClient.name,
      GoogleAnalytics4Tags.eventAction.load,
      GoogleAnalytics4Tags.referAClient.load.personalDetailsPageLoad
    );
    TriggerGoogleAnalyticsTag(
      GoogleAnalyticTags.eventAction.click,
      GoogleAnalyticTags.referAClient.click.individualButton
    );
    TriggerGoogleAnalytics4Tag(
      GoogleAnalytics4Tags.referAClient.name,
      GoogleAnalytics4Tags.eventAction.click,
      GoogleAnalytics4Tags.referAClient.click.individualButton
    );
    TriggerGoogleAnalytics4Tag(
      GoogleAnalytics4Tags.referralType.name,
      GoogleAnalytics4Tags.eventAction.click,
      GoogleAnalytics4Tags.referralType.click.referralTypeValue,
      { referral_type_value: PFX }
    );
    Cookies.remove("refer");
    Cookies.remove("refer1");
    Cookies.remove("buyingCurrency");
    Cookies.remove("sellingCurrency");
    Cookies.remove("est_transaction_value");
  }

  render() {
    const {
      classes,
      translate,
      loadingState,
      etvOptions,
      getServicesErrorObj
    } = this.props;

    const {
      step,
      steps,
      isAlertToBeShown
    } = this.state;

    const max = steps.length - 1;
    const dialingCodeData: DialingCodeObj = GetDialingCodeWithAuth();

    return (
      <div className={classes.referralContainerWrapper}>
        {isAlertToBeShown && step === max &&
          <APAlertMessage
            className={`serverErrorMessage`}
            title={translate('app.api.error.title')}
            message={translate('app.api.error.message')}
            severity={"error"}
            icon={'error'}
            hideCloseIcon={false}
            onClose={() => {
              this.setState({
                isAlertToBeShown: false
              })
            }}
          />
        }
        <div className={classes.referralContainer}>
          {loadingState === 'LOADING' &&
            <APBackdropLoader open={true} />
          }
          {!this.state.complete && (
            <APStepContainer
              defaults={{
                customerType: PFX,
                mobile: { select: dialingCodeData?.dialingCode, input: '' }
              }}
              onComplete={this.onComplete}
              onContinue={this.onContinue}
              onBack={this.onBack}
              steps={this.state.stepsData}
              title={translate('refer.client.title')}
              dropdownOption={etvOptions}
              getClientTypeSteps={this.getStepData}
              formName={`referClient`}
              getServicesErrorObj={getServicesErrorObj}
            />
          )}
          {this.state.complete && (
            <ReferralSent onReturn={this.onClear} />
          )}

        </div>
      </div>
    );
  }
}

const mapStateToProps = (store: ReducerState) => ({
  loadingState: store.refer.loadingState,
  affiliateDetails: store.user.affiliateDetails,
  etvOptions: store.refer.etvOptions
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
  referClient: ReferralActions.referClient,
  referAffiliate: ReferralActions.referAffiliate,
  getETVDetails: ReferralActions.getETVDetails,
  getServicesErrorObj: servicesDowntimeAction.getServicesErrorObj
}, dispatch);

export default withTenant(
  withTranslate(
    withStyles(ReferContainerStyles)(
      connect(mapStateToProps, mapDispatchToProps)(ReferContainer)
    )
  )
);

